module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00009-fs8.dfe3f01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00009-fs8.png
// module id = 163
// module chunks = 0